import { useQuery } from "@tanstack/react-query";

import { getPatientRawResponsesScreening } from "~/providers/api/patientRawResponses";

export const useGetPatientRawResponsesScreening = (
  patientId: string,
  enabled = true,
) => {
  const { data, isLoading } = useQuery({
    queryFn: () => getPatientRawResponsesScreening(patientId),
    queryKey: ["getPatientRawResponsesScreening", patientId],
    enabled: enabled && !!patientId,
  });
  return { data, isLoading };
};
